import { combineEpics } from 'redux-observable'
import {
  joinChannelEpic,
  leaveChannelEpic,
  tokenPrivilegeWillExpireEpic,
  leaveChannelSuccessEpic,
  reJoinChannelActionEpic,
} from 'components/features/videoCalls/epics/clientEpic'
import { volumeIndicatorEpic } from 'components/features/videoCalls/epics/volumeIndicatorEpic'
import { muteAudioEpic, unmuteAudioEpic } from 'components/features/videoCalls/epics/muteAudioEpic'
import { muteVideoEpic, unmuteVideoEpic } from 'components/features/videoCalls/epics/muteVideoEpic'
import { screenShareEpic, stopScreenShareEpic, stopScreenShareOnLeaveChannelEpic } from 'components/features/videoCalls/epics/screenShareEpic'
import {
  publishLocalStreamEpic,
  unpublishLocalStreamEpic,
  switchDeviceEpic,
  recordingDeviceChangedEpic,
  publishedEpic,
} from 'components/features/videoCalls/epics/localStreamEpic'
import { permissionsEpic } from 'components/features/videoCalls/epics/permissionsEpic'
import { streamPausedEpic, streamAddedEpic, streamRemovedEpic } from 'components/features/videoCalls/epics/peersEpic'

export const videoCallEpics = combineEpics(
  joinChannelEpic,
  leaveChannelEpic,
  reJoinChannelActionEpic,
  tokenPrivilegeWillExpireEpic,
  leaveChannelSuccessEpic,

  publishLocalStreamEpic,
  unpublishLocalStreamEpic,
  switchDeviceEpic,
  recordingDeviceChangedEpic,
  publishedEpic,

  streamAddedEpic,
  streamRemovedEpic,
  streamPausedEpic,

  volumeIndicatorEpic,

  muteAudioEpic,
  muteVideoEpic,
  unmuteVideoEpic,
  unmuteAudioEpic,

  screenShareEpic,
  stopScreenShareEpic,
  stopScreenShareOnLeaveChannelEpic,

  permissionsEpic,
)
